export enum QuickJotsDataIndex {
  jot = 'jot',
  created_at = 'created_at',
  deleted_at = 'deleted_at',
}
